import { getDefaultHeader } from '../../services/serviceAPIHelper';

export const listInvoices = function (filters) {
    //let url = "http://private-anon-2b502330eb-webb2bbackend.apiary-mock.com/reservation/list";
    let url = process.env.REACT_APP_API_URL + 'invoices/list';
    let params = {
        prefilters: {
            FechaDesde: filters.fromDate,
            FechaHasta: filters.toDate,
            Expediente: '',
            CodigoFactura: '',
            NombreCliente: filters.clientName,
        },
        postfilters: {
            Estado: (filters.reservationState === 'all' ? '' : filters.reservationState)
        }
    };
    let bodycontent = JSON.stringify(params);
    return fetch(url, {
        method: 'POST',
        body: bodycontent,
        headers: getDefaultHeader(true)
    }).then(response => {
        return response.json();
    });
};

export const getInvoicePDFByLocalizador = function (path) {
    //let url = "https://private-anon-2b502330eb-webb2bbackend.apiary-mock.com/reservation/list";
    //reservation/U18X000055X01
    let url = process.env.REACT_APP_API_URL + path;
    return fetch(url, {
        method: 'GET',
        headers: getDefaultHeader(true)
    }).then(response => {
        return response.json();
    });
};

export const getInvoiceByLocalizador = function (LocalizadorOlympia) {
    //let url = "https://private-anon-2b502330eb-webb2bbackend.apiary-mock.com/reservation/list";
    //invoices
    let params = {
        prefilters: {
            Expediente: LocalizadorOlympia
        },
        postfilters: {

        }
    };
    let bodycontent = JSON.stringify(params);
    let url = process.env.REACT_APP_API_URL + 'invoices/list';
    return fetch(url, {
        method: 'POST',
        body: bodycontent,
        headers: getDefaultHeader(true)
    }).then(response => {
        return response.json();
    });
};



// WEBPACK FOOTER //
// ./src/components/Invoices/invoicesServices.js